import script from "./GiftCertificateModal.vue?vue&type=script&setup=true&lang=js"
export * from "./GiftCertificateModal.vue?vue&type=script&setup=true&lang=js"

import "./GiftCertificateModal.vue?vue&type=style&index=0&id=d882815a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d882815a"]])

export default __exports__